import React from "react";
import { getCatalogEntry } from "@/data/vipSimulatorCatalog";
import { useI18n } from "@/i18n/I18nProvider";
import KitItemCard from "./KitItemCard";

export default function WeaponSlotCard({
    placement,
    onRemoveFromKit,
    onOpenCustomize,
    draggable = true,
}) {
    const { t, item } = useI18n();
    const entry = getCatalogEntry(placement.catalogId);
    if (!entry) return null;
    const displayName = item(entry.name);

    const hasMods =
        placement.attachments &&
        Object.values(placement.attachments).some(Boolean);

    return (
        <div className="vip-sim-weapon-slot vip-sim-weapon-slot--compact">
            <KitItemCard
                placement={placement}
                entry={entry}
                onRemoveFromKit={onRemoveFromKit}
                draggable={draggable}
                compact
                onDoubleClick={() => onOpenCustomize?.(placement.instanceId)}
                hintTitle={t("simulator.weapon.hint", { name: displayName })}
            />
            {onOpenCustomize ? (
                <button
                    type="button"
                    className="vip-sim-weapon-slot__mods-btn"
                    aria-label={t("simulator.weapon.modsAria", { name: displayName })}
                    title={t("simulator.weapon.modsTitle")}
                    onPointerDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        onOpenCustomize(placement.instanceId);
                    }}
                >
                    {t("simulator.weapon.mods")}
                </button>
            ) : null}
            {hasMods ? <span className="vip-sim-weapon-slot__mod-badge" title={t("simulator.weapon.hasMods")} /> : null}
        </div>
    );
}
